const OAUTH_COOKIE_NAME = "_XH_COMMON_WECHAT";

import qs from "qs";

let xh = {
  // 改变页面Title
  changePageTitle: function (title) {
    document.title = title;
  },
  // 简单判断手机号码是否满足
  isPhone: function (phone) {
    if (phone !== "" && phone.length === 11) {
      return true;
    } else {
      return false;
    }
  },
  // 判断是否Android系统
  isAndroid: function () {
    let userAgent = navigator.userAgent;
    if (userAgent.indexOf("Android") > -1 || userAgent.indexOf("Linux") > -1) {
      return true;
    } else {
      return false;
    }
  },
  // 判断是否iOS系统
  isIos: function () {
    return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
  },
  // 判断是否webview（app中webview的头部包含有RastarGameH5）
  isWebview: function () {
    let userAgent = navigator.userAgent;
    if (userAgent.search("RastarGameH5") !== -1) {
      return true;
    } else {
      return false;
    }
  },
  // 判断是否微信浏览器
  isWeChat: function () {
    return /micromessenger/i.test(navigator.userAgent.toLowerCase());
  },
  isQQ: function () {
    return /qq/i.test(navigator.userAgent.toLowerCase());
  },
  // 设置Cookie（cookieName, cookieValue, saveTime, saveDomain）
  setCookie: function (name, value, time, domain) {
    let exp = new Date();
    exp.setTime(exp.getTime() + time * 24 * 60 * 60 * 1000);
    document.cookie =
      name +
      "=" +
      escape(value) +
      ";expires=" +
      exp.toGMTString() +
      ";domain=" +
      domain +
      ";path=/";
  },
  // 获取Cookie，只能获取当前域名下的
  getCookie: function (name) {
    let cname = name + "=";
    let ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(cname) === 0) return c.substring(cname.length, c.length);
    }
    return "";
  },
  // 获取Cookie数组并切割
  getCookieArray: function (name) {
    let nowCookie = xh.getCookie(name);
    if (nowCookie) {
      nowCookie = unescape(nowCookie);
      nowCookie = nowCookie.split("`");
      return nowCookie;
    } else {
      return [];
    }
  },
  // 获取URL的参数
  pareUrl: function (link) {
    return qs.parse(link.split("?")[1]);
  },
  // 去除html标签
  RemoveHtml: function (val) {
    if (val) {
      val = unescape(val.replace(/\\u/g, "%u"));
      val = val.replace(/&nbsp;/gi, "");
      val = val.replace(/&lt;|&amp;lt;/g, "<");
      val = val.replace(/&gt;|&amp;gt;/g, ">");
      // val = val.replace(/<[^>]+>/g, '')
      val = val.replace(/\.="(.*?)"|class="(.*?)"|style="(.*?)"/g, "");
      return val;
    }
  },
  // 将对象拼接成字符串链接
  getDataConfig: function (data = {}) {
    if (typeof data !== "object") return data;
    const arr = [];
    for (let key in data) {
      let res = `${key}=${data[key]}`;
      arr.push(res);
    }
    const str = arr.join("&");
    return str;
  },
  // 格式化时间戳
  fomate: function (millSeconds, fmt) {
    if (!millSeconds) {
      return "";
    }
    if (typeof millSeconds === "string") {
      millSeconds = parseInt(millSeconds);
    }
    if (!fmt) fmt = "yyyy-MM-dd hh:mm";
    let date = new Date(millSeconds);
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
      }
    }
    return fmt;
  },
  // 参数配置
  xhParams: {
    con_id: "ZDbU6J",
    version: "1.0",
    key: "z5OtAosetL6aOgRBfJiaWIlhqe",
    gameCenterKey: 'qrUFZHU0bw7oOzZ6zL1p'
  },
  // 随机字符串（默认12位字符，数字+小写字母）
  nonce(len) {
    len = len || 12;
    var $chars = "abcdefghijklmnopqrstuvwxyz1234567890";
    var maxPos = $chars.length;
    var pwd = "";
    for (var i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  toast: function (text) {
    const div = document.createElement("div");
    div.id = "toast";
    div.className = "toast";
    div.innerHTML = text;

    if (!document.getElementById("toast")) document.body.appendChild(div);

    new Promise((resolve) => {
      setTimeout(() => {
        div.className = "toast active";
        resolve();
      }, 300);
    });
    new Promise((resolve) => {
      setTimeout(() => {
        div.className = "toast";
        resolve();
      }, 1500);
    });
    new Promise((resolve) => {
      setTimeout(() => {
        document.body.removeChild(div);
        resolve();
      }, 300);
    });
  },
  // 获取微信授权信息
  getWxUserInfo() {
    let oauthCookie = this.getCookie(OAUTH_COOKIE_NAME);
    try {
      return JSON.parse(decodeURIComponent(oauthCookie));
    } catch (e) {
      return null;
    }
  },
  // 删除Cookie
  removeCookie: function (name, domain) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; ' + (domain ? 'domain=' + domain + ';' : '');
  }
};

export default xh;
